<div *ngIf="!editDetails">
  <!-- <div class="row  mb-5" *ngIf="fromFb === 'FB'">
        <div class="col-12 text-right">
            <ng-container>
                <button class="back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit()">
                    <i class="fa fa-pencil"></i>
                    Edit
                </button>
            </ng-container>
        </div>
    </div> -->

  <div class="row row-cols-5">
    <!-- <div class="col-md-4 mb-2">
            <p class="label-dark">Location</p>
            <label class="label-light">{{employeeJobDetails?.reportManagerlocation ?
                employeeJobDetails?.reportManagerlocation : "--" }}</label>
        </div> -->
    <div class="col-md-4 mb-2 pt-2">
      <p class="label-dark">HR Manager</p>
      <label class="label-light">{{employeeJobDetails?.hrManagerDetails?.employeeName ?
        employeeJobDetails?.hrManagerDetails?.employeeName : "--"}}</label>
    </div>
    <div class="col-md-4 mb-2 pt-2">
      <p class="label-dark">Reporting Manager</p>
      <label class="label-light">{{employeeJobDetails?.reportingManagerDetails?.employeeName ?
        employeeJobDetails?.reportingManagerDetails?.employeeName : "--"}}</label>
    </div>
    <div class="col-4 text-right editBtn">
      <ng-container *ngIf="viewEdit">
        <button class="mt-3 back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit()">
          <i class="fa fa-pencil"></i>
          Edit
        </button>
      </ng-container>
    </div>
  </div>
   <h5 class="sub-title mt-0">Work Location</h5>
  <ng-container *ngIf="employeeJobDetails?.workLocations && employeeJobDetails?.workLocations.length > 0; else noLocations">
  <ng-container *ngFor="let location of employeeJobDetails?.workLocations; let i = index">
    <div class="row row-cols-5">
      <div class="col-md-4 mb-2">
        <p class="label-dark">Country</p>
        <label class="label-light">{{ location?.parentCompanyCountry?.countryCode ? location?.parentCompanyCountry?.countryCode : "--" }}</label>
      </div>
      <div class="col-md-4 mb-2">
        <p class="label-dark">State</p>
        <label class="label-light" *ngIf="location?.parentCompanyStateProvinceCode && location?.listCompanyStates?.length > 0">{{ location?.parentCompanyStateProvinceCode }}</label>
        <label class="label-light" *ngIf="!location?.parentCompanyStateProvinceCode && location?.listCompanyStates?.length <= 0">{{ location?.parentCompanyStateProvinceName ? location?.parentCompanyStateProvinceName : "--" }}</label>
      </div>
      <div class="col-md-4 mb-2">
        <p class="label-dark">City</p>
        <label class="label-light">{{ location?.parentCompanyCity ? location?.parentCompanyCity : "--" }}</label>
      </div>
    </div>

  </ng-container>
</ng-container>
<ng-template #noLocations>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Country</p>
      <label class="label-light">--</label>
    </div>
    <div class="col-md-4 mb-2">
      <p class="label-dark">State</p>
      <label class="label-light">--</label>
    </div>
    <div class="col-md-4 mb-2">
      <p class="label-dark">City</p>
      <label class="label-light">--</label>
    </div>
  </div>
</ng-template>

  <!-- <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Country</p>
      <label class="label-light">{{employeeJobDetails?.parentCompanyCountry?.countryCode ?
        employeeJobDetails?.parentCompanyCountry?.countryCode : "--" }}</label>
    </div>
    <div class="col-md-4 mb-2">
      <p class="label-dark">State</p>
      <label class="label-light"
        *ngIf="listCompanyStates?.length > 0">{{employeeJobDetails?.parentCompanyStateProvinceCode ?
        employeeJobDetails?.parentCompanyStateProvinceCode : "--"}}</label>
      <label class="label-light"
        *ngIf="listCompanyStates?.length <= 0">{{employeeJobDetails?.parentCompanyStateProvinceName ?
        employeeJobDetails?.parentCompanyStateProvinceName : "--"}}</label>
    </div>
    <div class="col-md-4 mb-2">
      <p class="label-dark">City</p>
      <label class="label-light">{{employeeJobDetails?.parentCompanyCity ?
        employeeJobDetails?.parentCompanyCity : "--"}}</label>
    </div>
  </div> -->
  <div class="row mt-4 mb-4">
    <div class="col-12">
      <div class="position-relative">
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
  <h5 class="sub-title mt-0">Job Details</h5>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Job Profile</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.jobProfile ? employeeJobDetails?.jobProfile :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Employee Id</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.employeeId ? employeeJobDetails?.employeeId :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Company Name</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.companyDetails?.companyName ?
        employeeJobDetails?.companyDetails?.companyName :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Job Position</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.position ? employeeJobDetails?.position : "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Department</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.departmentDetails?.departmentName ?
        employeeJobDetails?.departmentDetails?.departmentName : "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Work Shift</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.shiftDetails?.shiftName ?
        employeeJobDetails?.shiftDetails?.shiftName : "--"}}</label>
    </div>
  </div>
  <!-- <div class="row row-cols-5">
        <div class="col-md-4 mb-2">
            <p class="label-dark">Job Family</p>
        </div>
        <div class="col mb-2">
            <label class="label-light">{{employeeJobDetails?.jobFamily}}</label>
        </div>
    </div> -->
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Employment Type</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.employeeTypeDetails?.employmentTypeName ?
        employeeJobDetails?.employeeTypeDetails?.employmentTypeName
        :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Hire Date</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.hireDate ? employeeJobDetails?.hireDate : "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Notice Period</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.noticePeriodDetails?.noticePeriod ?
        employeeJobDetails?.noticePeriodDetails?.noticePeriod : "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Email IDs for Background check</p>
    </div>
    <div class="col mb-2">
      <ng-container *ngFor="let bgCheckEmail of employeeJobDetails?.bgCheckDetailsList">
        <label class="label-light">{{bgCheckEmail?.emailId ? bgCheckEmail?.emailId : "--"}}</label>
      </ng-container>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Email IDs for Asset Allocation</p>
    </div>
    <div class="col mb-2">
      <ng-container *ngFor="let assetAllocationEmail of employeeJobDetails?.assetAllocationDetailsList">
        <label class="label-light">{{assetAllocationEmail?.emailId ? assetAllocationEmail?.emailId :
          "--"}}</label>
      </ng-container>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Compensation</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.compensation ? employeeJobDetails?.compensation :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Other Instructions</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.otherInstructions ? employeeJobDetails?.otherInstructions :
        "--"}}</label>
    </div>
  </div>
  <!-- <div class="row row-cols-5">
        <div class="col-md-4 mb-2">
            <p class="label-dark">Time taken</p>
        </div>
        <div class="col mb-2">
            <label class="label-light">Full time</label>
        </div>
    </div> -->
  <!-- <div class="row row-cols-5">
        <div class="col-md-4 mb-2">
            <p class="label-dark">FTE</p>
        </div>
        <div class="col mb-2">
            <label class="label-light">{{employeeJobDetails?.fte}}</label>
        </div>
    </div> -->
  <div class="row mt-4 mb-4">
    <div class="col-12">
      <div class="position-relative">
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
  <h5 class="sub-title mt-0">Client Location</h5>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Country</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.countryCode?.countryCode ?
        employeeJobDetails?.countryCode?.countryCode : "--" }}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">State</p>
    </div>
    <div class="col mb-2">
      <label class="label-light"
        *ngIf="listClientStates?.length > 0; else isplayStateName">{{employeeJobDetails?.stateProvinceCode ?
        employeeJobDetails?.stateProvinceCode : "--"}}</label>
      <ng-template #isplayStateName>
        {{employeeJobDetails?.stateProvinceCode ?
        employeeJobDetails?.stateProvinceCode : employeeJobDetails?.stateProvinceName}}
      </ng-template>
      <!-- <label class="label-light" *ngIf="listClientStates.length <= 0">{{employeeJobDetails?.stateProvinceName ?
                employeeJobDetails?.stateProvinceName : "--"}}</label> -->
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">City</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.city ?
        employeeJobDetails?.city : "--"}}</label>
    </div>
  </div>
  <div class="row mt-4 mb-4">
    <div class="col-12">
      <div class="position-relative">
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
  <!-- <div class="row row-cols-5">
        <div class="col-md-4 mb-2">
            <p class="label-dark">Work Space</p>
        </div>
        <div class="col mb-2">
            <label class="label-light">San Francisco</label>
        </div>
    </div> -->
  <!-- <div class="row row-cols-5">
        <div class="col-md-4 mb-2">
            <p class="label-dark">Notice Period</p>
        </div>
        <div class="col mb-2">
            <label class="label-light">{{employeeJobDetails?.noticePeriodDate  ? employeeJobDetails?.noticePeriodDate : "--"}}</label>
        </div>
    </div> -->
  <h5 class="sub-title">Work authorization Details</h5>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Authorisation Type</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.authorizationType ? employeeJobDetails?.authorizationType :
        "--"}}</label>
    </div>
  </div>
  <div class="row row-cols-5">
    <div class="col-md-4 mb-2">
      <p class="label-dark">Linked LCA</p>
    </div>
    <div class="col mb-2">
      <label class="label-light">{{employeeJobDetails?.linkedLca ? employeeJobDetails?.linkedLca : "--"}}</label>
    </div>
  </div>
</div>

<div *ngIf="editDetails" class="edit-beneficiary-profile">

  <form [formGroup]="empJobDetailsForm" #f="ngForm" (ngSubmit)="saveEmpJobDetails()">
    <div class="row mt-2">
      <div class="col-4" formGroupName="hrManagerDetails">
        <label class="label-cls required">HR Manager</label>
        <div class="dd-position">
          <p-dropdown [options]="hrEmployeeList" formControlName="employeeId" optionLabel="employeeFullName"
            optionValue="employeeId" placeholder="Select"></p-dropdown>
        
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('hrManagerDetails').get('employeeId').touched) &&
                              empJobDetailsForm.get('hrManagerDetails').get('employeeId').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        </div>
      <div class="col-4" formGroupName="reportingManagerDetails">
        <label class="label-cls required">Reporting Manager</label>
        <div class="dd-position">
          <p-dropdown [options]="rmEmployeeList" formControlName="employeeId" optionLabel="employeeFullName"
            optionValue="employeeId" placeholder="Select"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('reportingManagerDetails').get('employeeId').touched) &&
                              empJobDetailsForm.get('reportingManagerDetails').get('employeeId').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
    </div>

  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Work Location</h5>
    </div>
  </div>
  <div class="row mt-2" formArrayName="workLocations">
  
    <ng-container *ngFor="let location of empJobDetailsForm.get('workLocations')['controls']; let i = index">
      <div class="col-3 container-margin" [formGroupName]="i">
        <div formGroupName="parentCompanyCountry">
        <label class="label-cls required">Country</label>
        <div class="dd-position-loc">
          <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode"
            optionLabel="countryName" optionValue="countryCode" (onChange)="handleCountryChange($event.value, 'company', i)"
            placeholder="Select Country">
          </p-dropdown>
          <span class="invalid-message"
            *ngIf="location.get('parentCompanyCountry').touched && location.get('parentCompanyCountry').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        </div>
      </div>
      <div class="col-3 container-margin" *ngIf="location.get('listCompanyStates')?.value?.length > 0" [formGroupName]="i">
        <label class="label-cls required">State</label>
        <div class="dd-position-loc">
          <p-dropdown class="w-100" [options]="location.get('listCompanyStates').value"
            formControlName="parentCompanyStateProvinceCode" optionLabel="stateProvinceName" optionValue="stateProvinceCode"
            placeholder="Select State">
          </p-dropdown>
          <span class="invalid-message"
            *ngIf="(location.get('parentCompanyStateProvinceCode').touched ) && location.get('parentCompanyStateProvinceCode').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-3 container-margin" *ngIf="location.get('listCompanyStates')?.value?.length <= 0" [formGroupName]="i">
        <label class="label-cls text-label required">State</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error': (location.get('parentCompanyStateProvinceName').touched) && location.get('parentCompanyStateProvinceName').errors?.required}"
          formControlName="parentCompanyStateProvinceName" placeholder="Enter your State">
  
        <span class="invalid-message"
          *ngIf="(location.get('parentCompanyStateProvinceName').touched ) && location.get('parentCompanyStateProvinceName').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-3 container-margin" [formGroupName]="i">
        <label class="label-cls text-label required">City</label>
  
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error': (location.get('parentCompanyCity').touched ) && location.get('parentCompanyCity').errors?.required}"
          formControlName="parentCompanyCity" placeholder="Enter City">
        <span class="invalid-message"
          *ngIf="(location.get('parentCompanyCity').touched ) && location.get('parentCompanyCity').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-3">
        <button type="button" class="remove-button" (click)="removeLocation(i)">x</button>
      </div>
  
    </ng-container>
  </div>
  
  <div class="row mt-2">
    <div class="col-6">
      <button type="button" class="btn btn-primary" (click)="addLocation()">Add Location</button>
    </div>
  </div>
    <!-- <div class="row mt-4">
      <div class="col-12">
        <h5 class="labelText">Company Location</h5>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4" formGroupName="parentCompanyCountry">
        <label class="label-cls required">Country</label>
        <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
          optionValue="countryCode" (onChange)="
            handleCountryChange($event.value, 'company')" placeholder="Select Country"></p-dropdown>
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('parentCompanyCountry').get('countryCode').touched) &&
            empJobDetailsForm.get('parentCompanyCountry').get('countryCode').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4" *ngIf="listCompanyStates?.length">
        <label class="label-cls required">State</label>
        <p-dropdown class="w-100" [options]="listCompanyStates" formControlName="parentCompanyStateProvinceCode"
          optionLabel="stateProvinceName" optionValue="stateProvinceCode" placeholder="Select State"></p-dropdown>
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('parentCompanyStateProvinceCode').touched ) &&
                empJobDetailsForm.get('parentCompanyStateProvinceCode').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4" *ngIf="!listCompanyStates?.length">
        <label class="label-cls required">State</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('parentCompanyStateProvinceName').touched ) && empJobDetailsForm.get('parentCompanyStateProvinceName').errors?.required}"
          formControlName="parentCompanyStateProvinceName" placeholder="Enter your State" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('parentCompanyStateProvinceName').touched ) &&
                empJobDetailsForm.get('parentCompanyStateProvinceName').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4">
        <label class="label-cls required">City</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('parentCompanyCity').touched ) && empJobDetailsForm.get('parentCompanyCity').errors?.required}"
          formControlName="parentCompanyCity" placeholder="Enter City" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('parentCompanyCity').touched ) &&
                empJobDetailsForm.get('parentCompanyCity').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div> -->
    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="position-relative">
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <h5 class="labelText">Job Details</h5>
      </div>
    </div>
    <div class="row mt-2 pb-3">
      <div class="col-4 text-pos">
        <label class="label-cls text-label required">Job Profile</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('jobProfile').touched ) && empJobDetailsForm.get('jobProfile').errors?.required}" formControlName="jobProfile"
          placeholder="Job Profile" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('jobProfile').touched ) &&
                empJobDetailsForm.get('jobProfile').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4 text-pos">
        <label class="label-cls text-label required">Employee Id</label>
        <input disabled type="text" class="im-input" formControlName="employeeId"
          [ngClass]="{ 'im-input-error':
                (empJobDetailsForm.get('employeeId').touched ) && empJobDetailsForm.get('employeeId').errors?.required}" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('employeeId').touched ) &&
                empJobDetailsForm.get('employeeId').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4 container-margin" formGroupName="companyDetails">
        <label class="label-cls required">Company Name</label>
        <div class="dd-position">
          <p-dropdown [options]="companyList" formControlName="companyId" optionLabel="companyName" optionValue="companyId"
            placeholder="Select Company Type"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('companyDetails').get('companyId').touched) &&
                          empJobDetailsForm.get('companyDetails').get('companyId').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
    </div>
    <div class="row mt-2 pb-3">
        <div class="col-4 container-margin" formGroupName="jobPosition">
            <label class="label-cls required">Job Position</label>
            <div class="dd-position">
              <p-dropdown [options]="jobPositionList" formControlName="id" optionLabel="name"
                optionValue="id" placeholder="Select Job Position"></p-dropdown>
              <span class="invalid-message" *ngIf="(empJobDetailsForm.get('jobPosition').get('id').touched ) &&
                            empJobDetailsForm.get('jobPosition').get('id').errors?.required ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
        </div>
      <div class="col-4 container-margin" formGroupName="departmentDetails">
        <label class="label-cls required">Department</label>
        <div class="dd-position">
          <p-dropdown [options]="departmentList" formControlName="id" optionLabel="deptName"
            optionValue="id" placeholder="Select Department"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('departmentDetails').get('id').touched ) &&
                            empJobDetailsForm.get('departmentDetails').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4 container-margin" formGroupName="shiftDetails">
        <label class="label-cls required">Work Shift</label>
        <div class="dd-position">
          <p-dropdown [options]="shiftList" formControlName="id" optionLabel="name" optionValue="id"
            placeholder="Select Shift"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('shiftDetails').get('id').touched ) &&
                            empJobDetailsForm.get('shiftDetails').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>


      <!-- <div class="col-4">
                <label class="label-cls required">Job Family</label>
                <input type="text" class="im-input"
                    [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('jobFamily').touched ) && empJobDetailsForm.get('jobFamily').errors?.required}"
                    formControlName="jobFamily" placeholder="Enter your Job Family" />
                <span class="invalid-message" *ngIf="(empJobDetailsForm.get('jobFamily').touched ) &&
                empJobDetailsForm.get('jobFamily').errors?.required ">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
                <span class="invalid-message" *ngIf=" (empJobDetailsForm.get('jobFamily').touched ) &&
                empJobDetailsForm.get('jobFamily').errors?.pattern">
                    {{ getGlobalErrorMessages("NUMBER_ONLY") }}
                </span>
            </div> -->
    </div>

    <div class="row mt-2 pb-3">
      <div class="col-4 container-margin" formGroupName="employeeTypeDetails">
        <label class="label-cls required">Employment Type</label>
        <div class="dd-position">
          <p-dropdown [options]="employementTypeList" formControlName="id" optionLabel="name" optionValue="id"
            placeholder="Select Employment Type"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('employeeTypeDetails').get('id').touched) &&
                              empJobDetailsForm.get('employeeTypeDetails').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>

      <div class="col-4 container-margin">
        <label class="label-cls required">Hire Date</label>
        <div class="dd-position">
          <p-calendar yearRange="1900:2100" id="hireDate" appendTo="body" class="im-input-calendar mw-100 datePicker-emp"
            formControlName="hireDate" yearNavigator="true" monthNavigator="true" showIcon="true" showButtonBar="true"
            inputId="icon" [showIcon]="true" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" name="hireDate">
          </p-calendar>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('hireDate').touched ) &&
                        empJobDetailsForm.get('hireDate').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4 container-margin" formGroupName="noticePeriodDetails">
        <label class="label-cls required">Notice Period</label>
        <div class="dd-position">
          <p-dropdown [options]="getNoticePeriod" formControlName="id" optionLabel="name" optionValue="id"
            placeholder="Notice Period"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('noticePeriodDetails').get('id').touched ) &&
                            empJobDetailsForm.get('noticePeriodDetails').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>

      <!-- <div class="col-4">
                <label class="label-cls required">Time Taken</label>
                <p-dropdown [options]="employeeType" formControlName="timeTaken" optionLabel="name" optionValue="code"
                    placeholder="Select Time Taken"></p-dropdown>
                <span class="invalid-message" *ngIf="(empJobDetailsForm.get('timeTaken').touched) &&
                    empJobDetailsForm.get('timeTaken').errors?.required">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div> -->
    </div>
    <div class="row mt-2">
      <div class="col-4 container-margin" formGroupName="bgCheckDetailsList">
        <label class="label-cls required">BGV Email Checklist</label>
        <div class="dd-position">
          <p-multiSelect [options]="BGcheckEmailList" formControlName="id" optionLabel="name" optionValue="id"
            defaultLabel="BGV Email"></p-multiSelect>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('bgCheckDetailsList').get('id').touched ) &&
                            empJobDetailsForm.get('bgCheckDetailsList').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4 container-margin" formGroupName="assetAllocationDetailsList">
        <label class="label-cls required">Asset Allocation Email Checklist</label>
        <div class="dd-position">
          <p-multiSelect [options]="getAssetAllocationlist" formControlName="id" optionLabel="name" optionValue="id"
            defaultLabel="Asset allocation Email"></p-multiSelect>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('assetAllocationDetailsList').get('id').touched ) &&
                            empJobDetailsForm.get('assetAllocationDetailsList').get('id').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4 container-pos">
        <label class="label-cls text-label required">Compensation</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('compensation').touched ) && empJobDetailsForm.get('compensation').errors?.required}"
          formControlName="compensation" placeholder="Compensation" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('compensation').touched ) &&
                empJobDetailsForm.get('compensation').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="row row mt-2">
      <div class="col-12 container-pos">
        <label class="label-cls text-label required">Other Instructions</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('otherInstructions').touched ) && empJobDetailsForm.get('otherInstructions').errors?.required}"
          formControlName="otherInstructions" placeholder="otherInstructions" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('otherInstructions').touched ) &&
                empJobDetailsForm.get('otherInstructions').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="position-relative">
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <h5 class="labelText">Client Location</h5>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-4" formGroupName="countryCode">
        <label class="label-cls required">Country</label>
        <div class="dd-position-loc">
          <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
            optionValue="countryCode" (onChange)="
                    handleCountryChange($event.value, 'client', 0)" placeholder="Select Country"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('countryCode').get('countryCode').touched) &&
                    empJobDetailsForm.get('countryCode').get('countryCode').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4" *ngIf="listClientStates?.length">
        <label class="label-cls required">State</label>
        <div class="dd-position-loc">
          <p-dropdown class="w-100" [options]="listClientStates" formControlName="stateProvinceCode"
            optionLabel="stateProvinceName" optionValue="stateProvinceCode" placeholder="Select State"></p-dropdown>
          <span class="invalid-message" *ngIf="(empJobDetailsForm.get('stateProvinceCode').touched ) &&
                        empJobDetailsForm.get('stateProvinceCode').errors?.required ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="col-4" *ngIf="!listClientStates?.length">
        <label class="label-cls text-label required">State</label>
        <input type="text" class="im-input"
          [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('stateProvinceName').touched ) && empJobDetailsForm.get('stateProvinceName').errors?.required}"
          formControlName="stateProvinceName" placeholder="Enter your stateProvinceName" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('stateProvinceName').touched ) &&
                empJobDetailsForm.get('stateProvinceName').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4">
        <label class="label-cls text-label  required">City</label>
        <input type="text" class="im-input" [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('city').touched ) && empJobDetailsForm.get('city').errors?.required}"
          formControlName="city" placeholder="Enter City" />
        <span class="invalid-message" *ngIf="(empJobDetailsForm.get('city').touched ) &&
                empJobDetailsForm.get('city').errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <!-- <div class="col-4">
                <label class="label-cls required">FTE</label>
                <input type="text" class="im-input" [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('fte').touched ) && empJobDetailsForm.get('fte').errors?.required}"
                    formControlName="fte" placeholder="Enter your FTE" />
                <span class="invalid-message" *ngIf="(empJobDetailsForm.get('fte').touched ) &&
                empJobDetailsForm.get('fte').errors?.required ">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>

            </div> -->
      <!-- <div class="col-4">
                <label class="label-cls required">Work Space</label>
                <input type="text" class="im-input"
                    [ngClass]="{ 'im-input-error':
                  (empJobDetailsForm.get('workSpace').touched ) && empJobDetailsForm.get('workSpace').errors?.required}" formControlName="workSpace"
                    placeholder="Enter your Work Space" />
                <span class="invalid-message" *ngIf="(empJobDetailsForm.get('workSpace').touched ) &&
                empJobDetailsForm.get('workSpace').errors?.required ">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div> -->
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="position-relative">
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <h5 class="labelText">Work authorization Details</h5>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-4 container-pos">
        <label class="label-cls text-label">Authorisation Type</label>
        <input type="text" class="im-input" formControlName="authorizationType" placeholder="Enter" />
        <!-- <span class="invalid-message" *ngIf="(empJobDetailsForm.get('authorizationType').touched ) &&
                empJobDetailsForm.get('authorizationType').errors?.required ">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span> -->
      </div>
      <div class="col-4 container-pos">
        <label class="label-cls text-label">Linked LCA</label>
        <input type="text" class="im-input" formControlName="linkedLca" placeholder="Enter" />
        <!-- <span class="invalid-message" *ngIf="(empJobDetailsForm.get('linkedLca').touched) &&
                empJobDetailsForm.get('linkedLca').errors?.required ">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span> -->
      </div>
    </div>
    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="position-relative">
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>

    <div class="row pt-3">
      <div class="col-md-2">
        <button type="submit" class="btn btn-success button-width-icon-left mr-3" [disabled]="empJobDetailsForm.invalid"
          [ngClass]="{'invalidBtn': empJobDetailsForm.invalid }">
          <i class="fa fa-floppy-o"></i> Save
        </button>
      </div>
      <div class="col-md-2">
        <button pButton type="button" label="Cancel" title="Cancel" class="p-button-secondary cancel-btn button-width-icon-left
                        d-flex alogn-items-center" (click)="handleCancel(f)">
        </button>
      </div>
    </div>

  </form>

</div>
